export const SummaryCalculation = (
  objEntItem,
  objAddLess,
  objTaxDetails,
  AutoRoundOff
) => {
  let dItemAmt = 0,
    dAddLessItemAmt = 0,
    BillAmt = 0,
    dSumItemDiscValue = 0,
    dSumCashDiscValue = 0,
    dSumBillDiscValue = 0,
    dAddLessBillDiscValue = 0,
    dTCSTaxAmt = 0,
    dSumItemTaxAmt = 0,
    dSumAddLessTaxAmt = 0;

  let objEntSummary = {
    Qty: 0,
    GoodsValue: 0,
    TotalDiscount: 0,
    TotalTax: 0,
    TotalAddLess: 0,
    TotalTCSTax: 0,
    RoundOff: 0,
    NetAmt: 0,
  };

  const items = objEntItem || [];
  const addLess = objAddLess || [];
  const taxes = objTaxDetails || [];

  const tcsRows = taxes.filter((T) => Number(T.Level) === 2);
  for (let i = 0; i < tcsRows.length; i++) {
    dTCSTaxAmt += Number(tcsRows[i].TaxAmt) || 0;
  }
  for (let i = 0; i < items.length; i++) {
    dItemAmt += Number(items[i].ItemAmt) || 0;
    dSumItemDiscValue += Number(items[i].ItemDiscValue) || 0;
    dSumCashDiscValue += Number(items[i].CashDiscValue) || 0;
    dSumBillDiscValue += Number(items[i].BillDiscValue) || 0;
    dSumItemTaxAmt += Number(items[i].TaxAmt) || 0;
    objEntSummary.Qty += Number(items[i].Qty) || 0;
    objEntSummary.GoodsValue += Number(items[i].GoodsValue) || 0;
  }
  for (let i = 0; i < addLess.length; i++) {
    dAddLessItemAmt += Number(addLess[i].itemAmt) || 0;
    objEntSummary.TotalAddLess += Number(addLess[i].taxableAmt) || 0;
    dSumAddLessTaxAmt += Number(addLess[i].taxAmt) || 0;
  }
  BillAmt = dItemAmt + dTCSTaxAmt + dAddLessItemAmt - dAddLessBillDiscValue;

  objEntSummary.TotalDiscount = round2(
    dSumItemDiscValue +
      dSumBillDiscValue +
      dAddLessBillDiscValue +
      dSumCashDiscValue
  );
  objEntSummary.TotalTax = round2(dSumItemTaxAmt + dSumAddLessTaxAmt);
  objEntSummary.TotalTCSTax = round2(dTCSTaxAmt);
  objEntSummary.GoodsValue = round2(objEntSummary.GoodsValue);
  objEntSummary.TotalAddLess = round2(objEntSummary.TotalAddLess);
  objEntSummary.RoundOff = fnRoundOff(BillAmt, AutoRoundOff);
  objEntSummary.NetAmt = fnRound(BillAmt, AutoRoundOff);

  return objEntSummary;
};
const round2 = (n) => {
  const x = Number(n);
  return Number.isFinite(x) ? Math.round((x + Number.EPSILON) * 100) / 100 : 0;
};
const roundingUnit = (AutoRoundOff) => {
  if (AutoRoundOff === undefined || AutoRoundOff === null || AutoRoundOff === "")
    return 0.01;
  if (typeof AutoRoundOff === "string" && AutoRoundOff.includes(".")) {
    const n = Number(AutoRoundOff);
    if (!Number.isFinite(n) || n === 0) return 0.01;
    return n;
  }
  const n = Number(AutoRoundOff);
  if (!Number.isFinite(n) || n === 0) return 0.01;
  return n;
};
const fnRoundOff = (dAmt, AutoRoundOff) => {
  const amt = Number(dAmt);
  if (!Number.isFinite(amt)) return 0;
  const unit = roundingUnit(AutoRoundOff);
  const rounded = Math.round(amt / unit) * unit;
  return round2(rounded - amt);
};
const fnRound = (dAmt, AutoRoundOff) => {
  return round2((Number(dAmt) || 0) + fnRoundOff(dAmt, AutoRoundOff));
};

export default SummaryCalculation;
